<template>
    <div v-if="atendimento">
        <button
            class="btn btn-outline-secondary dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            title="Integração PACS"
            id="integracao-pacs-status-button"
            aria-haspopup="true"
            aria-expanded="false">
            <!-- <i class="fa fa-print" aria-hidden="true" v-if="icon !== false"></i> -->
            PACS
        </button>

        <div class="dropdown-menu" aria-labelledby="integracao-pacs-status-button">
            <a class="dropdown-item" href="#" @click="logComunicacao()">
                <i class="fa-solid fa-book fa-fw mr-2"></i>Log de Comunicação
            </a>

            <template v-if="listaProcedimentos && listaProcedimentos.length">

                <div class="dropdown-divider"></div>

                <div v-for="(atp, index) in listaProcedimentos" :key="index">
                    <a class="dropdown-item" href="#" @click="pacsEnviar(atp)">
                        <i class="fas fa-x-ray mr-2" :class="atp.st_pacs == 'OK' ? 'text-success' : 'text-muted'"></i>
                        {{ atp.procedimento.st_procedimento }}
                        <span class="text-muted">(AN: {{ atp.st_an }})</span>
                        <span class="badge badge-pill ml-2" :class=" atp.st_pacs != 'OK' ? 'badge-success' : 'badge-primary' ">{{ atp.st_pacs != "OK" ? "Enviar" : "Reenviar" }}</span>
                    </a>
                </div>

            </template>
        </div>

        <log-integracao ref="logInt" />
        
        <!-- <az-audio-recorder ref="azAudioRec"/> -->

        <pre v-if="1 == 0">{{ atendimento }}</pre>
    </div>
</template>

<script>
// import $ from "jquery";
import _ from "lodash";
// import * as moment from "moment";
// import AzInput from "../shared/forms/AzInput";
import { subscribe, unSubscribe } from "../../service/Notify";
import LogIntegracao from "../shared/audit/LogIntegracao.vue";
// import AzAudioRecorder from "../../components/util/AzAudioRecorder.vue";

export default {
    data() {
        return {
            canal: ""
        };
    },

    props: {
        atendimento: {
            type: Object,
            required: true
        },

        procs: {
            type: Array, 
            required: false
        }
    },

    components: {
        // AzInput,
        LogIntegracao,
        // AzAudioRecorder,
    },

    computed: {
        listaProcedimentos: function() {
            if ( this.procs && this.procs.length > 0 ) {
                return this.procs;
            }

            if (
                !this.atendimento ||
                !this.atendimento.atendimento_procedimentos
            )
                return [];

            return _.filter(
                this.atendimento.atendimento_procedimentos,
                function(atp) {
                    return (
                        atp.procedimento && atp.procedimento.id_modalidade_dicom
                    );
                }
            );
        }
    },

    methods: {
        pacsEnviar: function(atp) {
            this.$util.atualizar(this, {
                service: "pep",
                func: "enviar_pacs",
                dados: {
                    id_atendimento_procedimento:
                        atp.id_atendimento_procedimento,
                    id_atendimento: atp.id_atendimento,
                    reenviar: true
                },
                callback: res => {
                    this.$toast.add({
                        severity: res.status_code == 200 ? "success" : "error",
                        summary: "Atenção",
                        detail: res.msg
                            ? res.msg
                            : "Erro ao enviar procedimento para o PACS",
                        life: 3000
                    });
                }
            });
        },

        logComunicacao: function() {
            // this.$refs.azAudioRec.abrir()
            this.$refs.logInt.abrir(
                "atendimento",
                this.atendimento.id_atendimento,
                true
            );
        }
    },

    mounted() {
        this.canal = this.$store.state.dominio + '-' + this.atendimento.id_atendimento + '-integracao-pacs';

        subscribe(this.canal, "recarregar-pacs", () => {
            this.$emit("refresh");
        });
    },

    beforeDestroy() {
        unSubscribe(this.canal, "recarregar-pacs");
    }
};
</script>
